<script lang="ts">
	import type { SizeProps } from "../../templates/WeddingsProps";
	import { nbspify } from "../../../../core/utils/nbspify";
	import StaticPicture from "../Picture/StaticPicture.svelte";

	export let cakeSizeOption: SizeProps;

	enum Variant {
		bare = "bare",
		partiallyCovered = "partiallyCovered",
		creamed = "creamed",
		birch = "birch",
	}

	const variantNameMap: Record<Variant, string> = {
		[Variant.bare]: "nahý",
		[Variant.partiallyCovered]: "polonahý",
		[Variant.creamed]: "krémovaný",
		[Variant.birch]: "bříza",
	};
</script>

<div class="glide__slide">
	<div
		class="border-secondary-200 relative mx-auto flex h-[25rem] !w-[13.5rem] flex-col items-center rounded-lg border p-4 lg:h-[28.75rem] lg:!w-[18rem]"
		class:min-[500px]:items-start={!cakeSizeOption.priceDesc}
	>
		<div
			class="flex w-full flex-col gap-2 lg:flex-row {cakeSizeOption.priceDesc
				? 'mb-16 items-center justify-center lg:mb-10'
				: 'mb-2 items-baseline justify-between'}"
		>
			<p class="lg:text-md text-base font-semibold">{cakeSizeOption.portions} porcí</p>
			{#if !cakeSizeOption.priceDesc}
				<div class="flex flex-col text-xs lg:items-end lg:text-base">
					<p>{nbspify(`výška - max ${cakeSizeOption.height} cm`)}</p>
					<p>{nbspify(`podložka - max ${cakeSizeOption.pad} cm`)}</p>
				</div>
			{/if}
		</div>
		{#if cakeSizeOption.desc}
			<p class="text-3xs lg:text-2xs absolute left-4 right-4 top-[6.125rem] lg:top-[5.5rem] lg:text-center">
				{nbspify(cakeSizeOption.desc)}
			</p>
		{/if}
		<StaticPicture
			class="flex h-[12.5rem] items-end pb-6 lg:h-[16.875rem] lg:pb-10 {cakeSizeOption.priceDesc
				? 'lg mb-[1.5rem]'
				: ''}"
			image={cakeSizeOption.image}
			alt={cakeSizeOption.alt ?? "Vizualizace svatebního dortu"}
			height={270}
			width={246}
			loading="lazy"
		/>
		{#if cakeSizeOption.priceDesc}
			<p class="text-center">{nbspify(cakeSizeOption.priceDesc)}</p>
		{:else if cakeSizeOption.variants}
			<div class="grid w-full grid-cols-2 grid-rows-4 text-xs lg:text-base">
				{#each Object.values(Variant) as variant}
					<span class="font-semibold">{variantNameMap[variant]}</span>
					<span class="text-right">{nbspify(`${cakeSizeOption.variants[variant]} Kč`)}</span>
				{/each}
			</div>
		{/if}
	</div>
</div>
